import { render, staticRenderFns } from "./menuMesaAyuda.vue?vue&type=template&id=bf0a023e&scoped=true"
import script from "./menuMesaAyuda.vue?vue&type=script&lang=js"
export * from "./menuMesaAyuda.vue?vue&type=script&lang=js"
import style0 from "./menuMesaAyuda.vue?vue&type=style&index=0&id=bf0a023e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0a023e",
  null
  
)

export default component.exports